/* BG footer: mobile accordion for the link-list columns (<= 767px). Desktop lists are always open (CSS); the
   <button> heading keeps aria-expanded in sync so it reads correctly at any width. */
if (!customElements.get('bg-footer-accordion')) {
  customElements.define(
    'bg-footer-accordion',
    class BgFooterAccordion extends HTMLElement {
      constructor() {
        super();
        this.mq = window.matchMedia('(max-width: 767px)');
        this.onToggle = this.onToggle.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.sync = this.sync.bind(this);
      }

      connectedCallback() {
        this.toggle = this.querySelector('.bg-footer__toggle');
        if (!this.toggle) return;
        this.toggle.addEventListener('click', this.onToggle);
        this.mq.addEventListener('change', this.sync);
        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
        this.sync();
      }

      disconnectedCallback() {
        if (!this.toggle) return;
        this.toggle.removeEventListener('click', this.onToggle);
        this.mq.removeEventListener('change', this.sync);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      onToggle() {
        if (this.mq.matches) this.setOpen(!this.isOpen);
      }

      onBlockSelect(event) {
        if (this.mq.matches && this.contains(event.target)) this.setOpen(true);
      }

      setOpen(open) {
        this.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
      }

      sync() {
        if (this.mq.matches) {
          this.toggle.setAttribute('aria-expanded', String(this.isOpen));
        } else {
          this.classList.remove('is-open');
          this.toggle.setAttribute('aria-expanded', 'true');
        }
      }
    }
  );
}
